import { DataBean } from "../DataBean";

export class PhysicalTakingConstants extends DataBean {


    public async getPhysicalTakingConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPhysicalTakingConstants_Number", [id]);
    }

    //aqui

 
}